type Props = { onClose: () => void };

export function KbAiDetailsHeaderBar({ onClose }: Props) {
  return (
    <div className="flex items-center justify-between gap-3 border-b border-amber-200 bg-amber-100/40 px-3 py-2 dark:border-amber-800 dark:bg-amber-950/40">
      <div>
        <div className="text-sm font-semibold text-amber-950 dark:text-amber-100">AI processing</div>
        <div className="text-[11px] text-amber-900 dark:text-amber-200">
          Purpose, mic, run AI, gaps, and draft—nothing saves until you use Save below.
        </div>
      </div>
      <button
        type="button"
        className="shrink-0 rounded-full border border-amber-400 bg-white px-3 py-1 text-xs font-medium text-amber-900 hover:bg-amber-50 dark:border-amber-600 dark:bg-zinc-900 dark:text-amber-100 dark:hover:bg-amber-950/50"
        onClick={onClose}
      >
        Close
      </button>
    </div>
  );
}
